/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reaction/flee': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 8a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v5a.5.5 0 01-.5.5zM13 8a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM7 8a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2A.5.5 0 017 8zM14.33 10L10 17.5 5.67 10z"/>'
  }
})
